import { render } from "./globalData.vue?vue&type=template&id=2276fe9e&scoped=true"
import script from "./globalData.vue?vue&type=script&lang=js"
export * from "./globalData.vue?vue&type=script&lang=js"

import "./globalData.vue?vue&type=style&index=0&id=2276fe9e&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2276fe9e"]])

export default __exports__